import { useEffect, useState } from "react";
import { FaEdit, FaTimes } from "react-icons/fa";
import { ITaskOperationValue } from "../../models/Task";
import { getCorrectRemoteLabel } from "./module/utils";

// Import styles
import classes from "./TaskOperationRemoteField.module.scss";

interface TaskOperationFieldProps {
  attribute?: ITaskOperationValue;
  label: string;
  onChangeValue: (newValue: string | undefined, label: string) => void;
}

const TaskOperationRemoteField = (props: TaskOperationFieldProps) => {
  const { attribute, label, onChangeValue } = props;

  const [editingEnable, setEditingEnabled] = useState(false);
  const [value, setValue] = useState("");

  useEffect(() => {
    setValue(attribute?.newValue as string);
  }, []);

  const startEditing = () => {
    setValue("");
    setEditingEnabled(true);
  };

  const stopEditing = () => {
    setValue(attribute?.newValue as string);
    onChangeValue(undefined, label);
    setEditingEnabled(false);
  };

  const changeValueHandler = (e: any) => {
    if (!e) {
      return;
    }
    onChangeValue(e.target.value, label);
    setValue(e.target.value);
  };

  return (
    <div className={classes["field-wrapper"]}>
      <label htmlFor="input">{getCorrectRemoteLabel(label)}</label>
      <span>
        <input
          id="input"
          type="text"
          value={value}
          onChange={changeValueHandler}
          disabled={!editingEnable}
        />
        {!editingEnable && <FaEdit onClick={startEditing} />}
        {editingEnable && <FaTimes onClick={stopEditing} />}
      </span>
    </div>
  );
};

export default TaskOperationRemoteField;
